module.exports = __webpack_public_path__ + "static/media/landing_roundtrip.a59d1194.svg";